import api from '~/services/api';
import { cstProps, rowsUfProps, ufProps } from '../../types';

const getCST = async (): Promise<{
  data: cstProps[];
  success: boolean;
}> => {
  const { data } = await api.get('/classificacao-ibs-cbs/buscaCST');
  return data;
};

const getUFs = async (): Promise<{ data: ufProps[]; success: boolean }> => {
  const { data } = await api.get('/uf');
  return data;
};

const getUFOnRowClick = async (
  cod_ibs_cbs: number,
): Promise<{ data: rowsUfProps[]; success: boolean }> => {
  const { data } = await api.get('/classificacao-ibs-cbs/buscaUF', {
    params: { cod_ibs_cbs },
  });
  return data;
};

const getFlgPadrao = async (): Promise<{
  data: any;
  success: boolean;
}> => {
  const { data } = await api.get('/classificacao-ibs-cbs/flg-padrao');
  return data;
};

export const IbsCbsGetInfos = {
  getCST,
  getUFs,
  getUFOnRowClick,
  getFlgPadrao,
};
